import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class CreatedAtColumn extends Column {
    title = 'employees.documents.createdAt';
    property = 'createdAt';
    sortable = true;
    type: CellDisplay = CellDisplay.date;
}
